import { useMemo } from 'react'

import { useAppSelector } from '../../../../../store/hooks'
import { selectAccountId } from '../../../../../store/auth/authSlice'
import { useGetRoomSessionQuery } from '../../../../../store/media/media'
import { useGetAccountQuery } from '../../../../../store/accountUserSettings/accountUserSettings'
import { type IntegrationServiceId } from '../../../../../common/integrations'
import { getAccountLinkedFolderId } from '../../../../../common/linkedDocumentFolders'

export const useMeetingLinkedFolder = (
  serviceId?: IntegrationServiceId,
  roomId?: string,
  sessionId?: string,
): { folderIds: string[] | undefined; isLoading: boolean } => {
  const accountId = useAppSelector(selectAccountId)

  const { data, isLoading: isSessionLoading } = useGetRoomSessionQuery(
    { accountId, roomId: roomId ?? '', sessionId: sessionId ?? '' },
    { skip: !accountId || !roomId || !sessionId || !serviceId },
  )

  const { data: account, isLoading: isAccountLoading } = useGetAccountQuery({ accountId }, { skip: !accountId || !serviceId })

  const folderIds = useMemo(() => {
    const contactFolderIds = [
      ...new Set(
        (data?.data?.users ?? [])
          .filter((user) => user.type === 'external')
          .flatMap((user) => user.integrations ?? [])
          .filter((integration) => integration.serviceId === serviceId)
          .map((integration) => integration.externalId),
      ),
    ]
    if (contactFolderIds.length > 0) {
      return contactFolderIds
    }
    const accountFolderId = getAccountLinkedFolderId(account?.data, serviceId)
    return accountFolderId ? [accountFolderId] : undefined
  }, [data, account, serviceId])

  return { folderIds, isLoading: isSessionLoading || isAccountLoading }
}
